<div class="bx--modal-header">
  <h4 class="modal-heading">Password reset</h4>
</div>
<div class="bx--modal-content">
  @if (!isForgotPasswordEmailSent) {
    <div>
      <h3>Enter email address</h3>
      <p>
        Enter the email address associated with your account and we’ll send an email with a verification code to
        reset your password.
      </p>
      <app-input-text
        data-qa="email-input"
        inputId="login-email"
        label="Email address"
        name="email"
        [focusOnLoad]="true"
        [formGroup]="forgotPasswordForm"
        [hideLabel]="true"
        >
      </app-input-text>
      <a
        [routerLink]=""
        (click)="redirectToPasswordResetPage()"
        >I already have a verification code</a
        >
      </div>
    }
    @if (isForgotPasswordEmailSent) {
      <div>
        <h3>Check your email</h3>
        <p>
          If an account exists for {{email}}, you will receive an email with a verification code.
          Check your inbox and enter the verification code in the password reset page.
        </p>
      </div>
    }
    @if (isError) {
      <p
        data-qa="error-message"
        >
        {{ errorMessage }}
      </p>
    }
  </div>
  <div class="bx--modal-footer bx--btn-set">
    <button
      data-qa="cancel-button"
      pButton
      type="button"
      label="Close"
      class="bx--btn bx--btn--secondary"
      (click)="cancel()"
    ></button>
    @if (!isForgotPasswordEmailSent) {
      <button
        data-qa="confirm-button"
        pButton
        type="button"
        label="Send reset email"
        class="bx--btn bx--btn--primary"
        (click)="confirm()"
        [disabled]="forgotPasswordForm.invalid"
      ></button>
    }
    @if (isForgotPasswordEmailSent) {
      <button
        data-qa="reset-button"
        pButton
        type="button"
        label="Go to password reset page"
        class="bx--btn bx--btn--primary"
        (click)="confirm()"
      ></button>
    }
  </div>
